import { render, staticRenderFns } from "./FilterCounter.vue?vue&type=template&id=7b37c810&scoped=true&"
import script from "./FilterCounter.vue?vue&type=script&lang=js&"
export * from "./FilterCounter.vue?vue&type=script&lang=js&"
import style0 from "./FilterCounter.vue?vue&type=style&index=0&id=7b37c810&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37c810",
  null
  
)

export default component.exports